import usLangUnit from './Unit/us';
import usLangCategory from './Category/us';
import usLangSupplier from './Supplier/us';
import usLangWarehouse from './Warehouse/us';
import usLangActionWarehouse from './ActionWarehouse/us';
import usLangDiscount from './Discount/us';
import usLangProductLookup from './SearchProduct/us';

const usLangSell = {
  ...usLangUnit,
  ...usLangCategory,
  ...usLangSupplier,
  ...usLangWarehouse,
  ...usLangActionWarehouse,
  ...usLangDiscount,
  ...usLangProductLookup,
};

export default usLangSell;
